import styled from 'styled-components';

const ContainerStyle = styled.section`
	width: 100%;
	margin: 0 auto;

	&:not(.full) {
		width: 100%;
		padding-left: var(--contPaddingH);
		padding-right: var(--contPaddingH);
	}

	&.first-section {
		margin-top: var(--contMarginV);
	}

	&.section {
		margin-bottom: var(--contMarginV);
	}

	&.full {
		padding-left: 0;
		padding-right: 0;
	}
`;
export default ContainerStyle;
